import { createContext } from 'react'

const QueryParamsContext = createContext({})

export default QueryParamsContext
